var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuizBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 542,
    height: 385,
    viewBox: "0 0 542 385",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.72 22.2173C257.656 27.4187 256.724 17.8479 260.573 6.14062C264.421 -5.56669 270.946 -0.792502 270.946 -0.792502",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M312.171 292.755C314.107 297.957 313.176 288.386 317.024 276.678C320.872 264.971 327.397 269.745 327.397 269.745",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M254.55 10.2472L266.545 6.97025",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M311.001 280.785L322.996 277.508",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M276.464 3.02779C276.464 3.02779 269.229 12.9792 280.054 17.2478",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M332.915 273.566C332.915 273.566 325.68 283.517 336.505 287.786",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M286.625 0.213379C286.625 0.213379 298.43 4.65897 291.009 14.2214",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M343.076 270.751C343.076 270.751 354.882 275.197 347.46 284.759",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M278.506 6.40332L286.965 10.5891",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M334.957 276.941L343.416 281.127",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M285.159 4.591L278.508 11.6779",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M341.611 275.129L334.959 282.216",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5906 256.521C26.5906 256.521 6.49545 256.283 6.36922 267.959",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9003 263.88C24.4856 262.16 15.7481 259.975 14.2236 264.459C12.6992 268.944 23.5679 266.277 26.9337 264.186C26.9337 264.186 20.6928 268.252 22.5946 269.403",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1091 270.683C26.1091 270.683 23.4644 272.902 20.6103 271.837",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7144 262.949L28.6169 273.224C28.6169 273.224 36.2162 268.062 40.6126 269.743C46.0901 271.775 38.9661 277.297 33.1176 273.321",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3242 265.744C51.3242 265.744 55.2936 278.081 34.6633 278.473",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M320.909 56.7576L328.178 57.5797L328.255 68.7029L344.224 49.1822L369.348 52.0148",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M377.36 327.295L384.629 328.117L384.706 339.241L400.675 319.72L425.799 322.553",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M346.959 57.7556L357.981 70.9134",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M403.41 328.293L414.432 341.451",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M360.85 59.3211L341.051 69.0024",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M221.516 76.3404C219.659 74.7432 208.938 75.8566 211.105 80.9711C213.272 86.0856 222.145 79.2949 223.84 75.8888C223.84 75.8888 220.869 82.4008 223.825 82.8443",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M229.735 71.103L227.328 76.8293C227.328 76.8293 228.532 73.9175 230.638 73.9221C233.22 73.9277 232.276 76.84 228.974 76.2305",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M431.665 142.183L426.589 154.461L437.608 162.625",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M437.971 147.189L450.593 154.337",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M446.674 145.46L441.187 154.492",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M455.543 153.357C455.543 153.357 455.652 155.922 454.007 156.268",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M457.167 144.404L464.79 148.239",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M467.629 141.289L460.059 159.536",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M468.019 134.946L480.232 144.299L475.002 154.487",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M130.59 374.863L148.368 339.425L169.799 355.607L130.59 374.863Z",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M164.526 358.189L160.004 354.691L164.843 351.885",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3948 175.314C35.5941 172.77 39.9752 165.681 36.1805 159.482C32.3857 153.283 21.852 150.32 12.6528 152.865C3.45354 155.409 -0.927644 162.497 2.86712 168.697C6.66189 174.896 17.1956 177.859 26.3948 175.314Z",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5067 166.972C50.5494 166.995 59.5143 160.987 59.5304 153.551C59.5464 146.115 50.6076 140.067 39.5649 140.043C28.5222 140.019 19.5573 146.028 19.5412 153.464C19.5251 160.9 28.464 166.948 39.5067 166.972Z",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0943 152.199L20.6439 157.896",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5406 152.916L23.075 161.127",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1556 154.303L26.5146 163.592",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1736 157.041L31.5722 165.856",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4358 159.922L34.1567 166.474",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32638 148.502C0.754626 148.178 -3.56474 150.927 -0.2219 152.79C3.12094 154.653 3.98277 149.71 3.16458 147.814C3.16458 147.814 4.84473 151.383 6.37482 150.959",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6172 132.979L31.3723 140.064C31.3723 140.064 28.4948 136.522 30.5317 135.205C33.0165 133.578 36.2982 137.034 32.1404 138.472",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M131.059 132.363L139.199 137.577",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M139.21 131.03L132.372 137.874",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M147.229 133.019L155.384 130.987",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M159.303 125.273L164.26 128.237",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M168.068 121.737L161.761 136.237",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M524.344 119.593L524.021 108.498L536.471 108.525C536.471 108.525 529.57 111.075 532.731 117.046C535.891 123.018 541.006 119.629 541.006 119.629",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M502.843 308.794L517.024 302.258L535.776 303.182L536.91 319.194L523.133 325.799L506.141 324.927L502.843 308.794Z",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M506.141 324.927L519.861 318.312L536.91 319.194",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M519.874 318.312L517.024 302.258",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M502.843 308.794L521.551 310.292L535.776 303.182",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M521.547 310.291L523.129 325.799",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M505.683 188.555L505.031 209.896L532.82 201.465L505.683 188.555Z",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M505.687 188.555L518.879 205.574",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M516.763 202.839L519.982 201.797L522.14 204.706",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M263.561 186.01L275.026 194.321",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M275.134 184.918L265.464 193.796",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M279.846 180.586C280.398 180.415 281.028 180.398 281.598 180.54C282.168 180.681 282.633 180.969 282.889 181.341C282.979 181.474 283.042 181.614 283.075 181.759C283.634 183.625 279.084 186.044 279.084 186.044L285.562 186.058",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0486 61.4637C85.6085 56.758 87.9208 52.2252 91.772 48.2842C95.6232 44.3432 100.889 41.1211 107.083 38.9156",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M116.88 91.1619C106.362 89.4399 97.2422 85.0349 91.4443 78.8765",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M168.361 66.1225C167.455 73.5603 162.201 80.4466 153.755 85.2696C145.308 90.0925 134.359 92.4578 123.31 91.8462",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M130.083 35.7506C139.581 36.2839 148.529 38.9842 155.448 43.4048C162.366 47.8254 166.841 53.7014 168.13 60.0607",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M144.691 85.5003C138.855 87.6909 132.242 88.771 125.558 88.6251C118.875 88.4792 112.373 87.1128 106.748 84.672C101.122 82.2313 96.5853 78.808 93.6218 74.7682C90.6584 70.7284 89.3798 66.2241 89.923 61.7369",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3032 54.7864C94.2517 51.3925 97.2851 48.3297 101.189 45.8151C105.092 43.3004 109.77 41.3953 114.892 40.2347C120.014 39.074 125.454 38.6862 130.827 39.0987C136.2 39.5112 141.375 40.7139 145.985 42.6216C150.595 44.5294 154.528 47.0955 157.505 50.1384C160.482 53.1812 162.43 56.6264 163.212 60.23C163.994 63.8336 163.59 67.5075 162.029 70.9915C160.468 74.4756 157.788 77.6846 154.179 80.3915",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M123.124 45.9159L126.706 63.7982L147.114 59.568",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M444.696 99.2241C438.832 99.2496 433.092 98.0747 428.236 95.8552C423.38 93.6356 419.637 90.4761 417.503 86.7953C415.37 83.1144 414.946 79.0859 416.289 75.2433C417.631 71.4008 420.676 67.9256 425.02 65.2782",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M471.833 86.1004C470.421 88.8892 468.085 91.424 465.001 93.5127C461.917 95.6015 458.167 97.1895 454.034 98.1564",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M434.896 61.3366C442.138 59.6369 450.092 59.9452 457.007 62.1936C463.923 64.442 469.234 68.4465 471.772 73.3263",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M458.777 65.5164C461.764 66.8837 464.289 68.6614 466.183 70.7323C468.077 72.8031 469.299 75.1201 469.767 77.5305C470.235 79.9408 469.94 82.3897 468.9 84.7157C467.86 87.0417 466.099 89.1919 463.733 91.0246C461.368 92.8573 458.451 94.3308 455.176 95.348C451.901 96.3651 448.342 96.9028 444.733 96.9256C441.124 96.9483 437.548 96.4557 434.24 95.4801C430.932 94.5044 427.967 93.068 425.541 91.2656",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M420.345 85.3869C418.816 82.4417 418.504 79.2733 419.443 76.2209C420.383 73.1685 422.537 70.347 425.677 68.0584C428.816 65.7699 432.822 64.1004 437.266 63.2286C441.71 62.3569 446.424 62.3158 450.904 63.1097",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M434.736 69.0979L444.465 79.7368L435.562 87.4794",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M239.404 369.678C239.396 367.129 240.314 364.62 242.079 362.368C243.845 360.116 246.403 358.191 249.53 356.76",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M279.357 380.528C276.601 382.47 273.146 383.9 269.326 384.68C265.507 385.459 261.452 385.561 257.553 384.977C253.654 384.392 250.043 383.14 247.069 381.342C244.095 379.544 241.859 377.261 240.577 374.713",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M262.592 354.097C268.748 354.11 274.648 355.77 278.995 358.711C283.341 361.651 285.778 365.632 285.769 369.778",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M262.529 383.512C257.1 383.501 251.896 382.037 248.063 379.444C244.229 376.85 242.08 373.339 242.088 369.683",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M246.641 361.038C248.542 359.463 250.936 358.191 253.654 357.313C256.371 356.435 259.344 355.972 262.36 355.957C265.376 355.942 268.361 356.376 271.101 357.228C273.841 358.08 276.27 359.328 278.213 360.884C280.156 362.44 281.565 364.264 282.341 366.228C283.116 368.192 283.238 370.246 282.699 372.244C282.159 374.241 280.97 376.133 279.218 377.784C277.466 379.435 275.194 380.805 272.563 381.795",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M259.366 379.086L262.56 369.728L258.148 362.063",
    stroke: "#007BFF",
    strokeOpacity: 0.21,
    strokeWidth: 1.02226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizBg);
export default __webpack_public_path__ + "static/media/quiz_bg.4cff71d734f65047ac46c5ffadab1397.svg";
export { ForwardRef as ReactComponent };